import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const getPatientOscillaApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.patientOscilla,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const deletePatientOscillaApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.deletePatientOscilla,
    method: "delete",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const downloadAudiogramApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.downloadPatientOscilla,
    method: "get",
    responseType: "blob",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || err);

  return callResponse;
};
